import { dataFetcher } from 'core/services/requestHandler';   

const submitQuery = async (data = {}, config = {}) => {
  return dataFetcher('support/createRequest', data, {method: 'POST', ...config});
};

export { submitQuery };
